import { setRemoteUrlResolver } from '@nx/angular/mf';

const assetBaseUrl = (window as any).__ASSET_BASE_URL__ || location.origin;
setRemoteUrlResolver((appName) => `${assetBaseUrl}/apps/${appName}`);

// Inject font-face declarations dynamically using runtime asset path
const assetsPath = `${assetBaseUrl}/apps/assets`;
const fontStyles = document.createElement('style');
fontStyles.textContent = `
  @font-face {
    font-family: 'Muli';
    src: url('${assetsPath}/fonts/muli/Muli-Regular.ttf') format('truetype');
  }
  @font-face {
    font-family: 'Mulish';
    src: url('${assetsPath}/fonts/mulish/Mulish-Regular.ttf') format('truetype');
  }
  @font-face {
    font-family: 'Merriweather';
    src: url('${assetsPath}/fonts/merriweather/Merriweather-Regular.ttf') format('truetype');
  }
  @font-face {
    font-family: 'Merriweather-Bold';
    src: url('${assetsPath}/fonts/merriweather/Merriweather-Bold.ttf') format('truetype');
  }
`;
document.head.appendChild(fontStyles);

// eslint-disable-next-line no-console
import('./bootstrap').catch((err) => console.error(err));
